import { Subject } from 'rxjs';

export class ClubIDChangeEmmitter extends Subject<any>{
    constructor() {
        super();
    }
    emit(value) { super.next(value); }
}